import React from "react";

import RideNumberCellContent from "../components/RideNumberCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function rideNumber({ width, onResize }: Column.Options) {
	return base(
		ColumnId.RideNumber,
		(item) => <RideNumberCellContent item={item} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default rideNumber;
